import { Dispatch } from 'react-redux';
import * as _ from 'lodash';
import { AuthActionCreators, IApplicationState } from '@nkr/store/index';
import { IUserListResponse, IUser, ITicketGroup, IBaseResponse, ITicket, ITicketMessage, ITicketGroupUsersRequest, ITicketGroupCategory, ITicketRequest, IListItem, ICenterBase, ITicketTagName, ITag, ISelectItem, ITicketMessageRequest, ITicketPropertiesRequest, IContactForList, ITicketTag, ITicketCannedResponse, ITicketCannedResponseRequest, ITicketListRequest } from '@nkr/models/index';
import { MessageType, TicketVisibility, TicketProperty, TicketStatus, TicketType, TicketUrgency, TicketEntityType } from '@nkr/enums/index';
import { IPut, IDelete, IPost } from '../authorization/actions';
import { AxiosError } from 'axios';
import { ITicketForList } from '@nkr/models/ticketing/ticket-for-list';

export const ActionTypes = {
    SET_TICKET: 'SET_TICKET',
    UPDATE_TICKET: 'UPDATE_TICKET',
    UPDATE_TICKET_TAGS: 'UPDATE_TICKET_TAGS',
    ADD_TICKET_MESSAGE: 'ADD_TICKET_MESSAGE',
    SET_TICKET_LIST: 'SET_TICKET_LIST',
    SET_TICKET_GROUPS: 'SET_TICKET_GROUPS',
    UPDATE_TICKET_GROUPS: 'UPDATE_TICKET_GROUPS',
    ADD_TICKET_GROUP: 'ADD_TICKET_GROUP',
    REMOVE_TICKET_GROUP: 'REMOVE_TICKET_GROUP',
    SET_USER_LIST: 'SET_USER_LIST',
    SET_TICKET_GROUP_CATEGORY_LIST: 'SET_TICKET_GROUP_CATEGORY_LIST',
    SET_TICKETING_LOOKUP_DATA: 'SET_TICKETING_LOOKUP_DATA',
    UPDATE_ASSIGNED_USER: 'UPDATE_ASSIGNED_USER',
    UPDATE_ATTACHMENTS: 'UPDATE_ATTACHMENTS',
    SET_CANNED_RESPONSES: 'SET_CANNED_RESPONSES',
    REMOVE_CANNED_RESPONSE: 'REMOVE_CANNED_RESPONSE'
}

export interface ITicketingLookupData {
    ticketEntityTypeList: IListItem[],
    ticketTypeList: IListItem[],
    ticketGroupList: ITicketGroup[],
    ticketTierList: IListItem[],
    ticketStatusList: IListItem[],
    ticketUrgencyList: IListItem[],
    userList: IUser[],
    centerList: ICenterBase[],
    tagList: ITicketTagName[],
    nkrContactList: IContactForList[]
}

export interface ITicketingState {
    ticket: ITicket,
    tickets: ITicket[],
    groups: ITicketGroup[],
    users: IUser[],
    categories: ITicketGroupCategory[],
    cannedResponses: ITicketCannedResponse[],
    lookupData: ITicketingLookupData
}

export interface ITicketResponse {
    data: {
        success: boolean,
        message: string,
        results: ITicket
    }
}

export interface ITicketMessageResponse {
    data: {
        success: boolean,
        message: string,
        results: ITicketMessage
    }
}

export interface ITicketListResponse {
    data: {
        success: boolean,
        message: string,
        results: ITicketForList[]
    }
}

export interface ITicketGroupListResponse {
    data: {
        success: boolean,
        message: string,
        results: ITicketGroup[]
    }
}

export interface ITicketGroupResponse {
    data: {
        success: boolean,
        message: string,
        results: ITicketGroup
    }
}

export interface ITicketGroupCategoryListResponse {
    data: {
        success: boolean,
        message: string,
        results: ITicketGroupCategory[]
    }
}

export interface ITicketLookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: ITicketingLookupData
    }
}

export interface ITagListResponse {
    data: {
        success: boolean,
        message: string,
        results: string[]
    }
}

export interface ICannedResponseListResponse {
    data: {
        success: boolean,
        message: string,
        results: ITicketCannedResponse[]
    }
}

export interface ICannedResponseResponse {
    data: {
        success: boolean,
        message: string,
        results: ITicketCannedResponse
    }
}

// export interface ICannedResponseInsertUpdateResponse {
//     data: {
//         success: boolean,
//         message: string,
//         results: ITicketCannedResponse
//     }
// }

export const ActionCreators = {
    getTicket: (ticketId: number) => (dispatch: Dispatch<IApplicationState>): Promise<ITicketResponse> => {
        let options = {
            url: __API__ + '/ticketing/ticket/' + ticketId
        };

        return dispatch<any>(AuthActionCreators.apiGet(options)).then((response: ITicketResponse) => {
            if (response.data.success)
                dispatch<any>(ActionCreators.setTicket(response.data.results));

            return Promise.resolve(response);
        });
    },
    setTicket: (ticket: ITicket) => {
        return {
            type: ActionTypes.SET_TICKET,
            ticket
        };
    },

    saveTicket: (newTicket: ITicketRequest) => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<ITicketResponse> => {
        let formData = new FormData();

        formData.append('id', newTicket.id.toString());
        formData.append('fromEmail', newTicket.fromEmail);
        formData.append('contactId', newTicket.contactId != null ? newTicket.contactId.toString() : null);
        formData.append('firstName', newTicket.firstName);
        formData.append('lastName', newTicket.lastName);
        formData.append('email', newTicket.email);
        formData.append('phoneNumber', newTicket.phoneNumber);

        newTicket.cc.forEach(item => {
            formData.append('cc', item);
        });

        formData.append('subject', newTicket.subject);
        formData.append('description', newTicket.description);
        formData.append('groupId', newTicket.groupId.toString());
        formData.append('assignedUserId', newTicket.assignedUserId.toString());
        formData.append('entityType', newTicket.entityType != null ? newTicket.entityType.toString() : null);
        formData.append('entityTypeId', newTicket.entityTypeId != null ? newTicket.entityTypeId.toString() : null);
        formData.append('ticketStatusId', newTicket.ticketStatusId.toString());
        formData.append('ticketTypeId', newTicket.ticketTypeId != null ? newTicket.ticketTypeId.toString() : null);
        formData.append('tierLevelId', newTicket.tierLevelId != null ? newTicket.tierLevelId.toString() : null);
        formData.append('urgency', newTicket.urgency.toString());
        formData.append('isEmail', newTicket.isEmail.toString());

        newTicket.tags.forEach(tag => {
            formData.append('tags', tag);
        });

        newTicket.files.forEach(file => {
            formData.append('files', file);
        });

        let options = {
            url: __API__ + '/ticketing/ticket',
            data: formData
        };

        return dispatch<any>(AuthActionCreators.apiPostFormData(options)).then((response: ITicketResponse) => {
            return Promise.resolve(response);
        });
    },
    updateTicket: (property: TicketProperty, value: string) => {
        return {
            type: ActionTypes.UPDATE_TICKET,
            property,
            value
        };
    },
    updateTicketTags: (list: ISelectItem[]) => {
        return {
            type: ActionTypes.UPDATE_TICKET_TAGS,
            list
        };
    },
    saveTicketProperties: () => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<IBaseResponse> => {
        let ticket = getState().ticketing.ticket;
        let { id, groupId, assignedUserId, entityType, entityTypeId, ticketStatusId, ticketTypeId, tierLevelId, urgencyId: urgency, tags } = ticket;

        let request: ITicketPropertiesRequest = {
            id,
            groupId,
            assignedUserId,
            entityType,
            entityTypeId,
            ticketStatusId,
            ticketTypeId,
            tierLevelId,
            urgency,
            tags: tags.map(x => x.tag)
        };

        let options: IPut = {
            url: __API__ + '/ticketing/ticket',
            data: request
        };

        return dispatch<any>(AuthActionCreators.apiPut(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },

    saveTicketMessage: (type: MessageType, from: string, to: ISelectItem, cc: ISelectItem[], bcc: ISelectItem[], subject: string, message: string, visibility: TicketVisibility, parentMessageId: number, files: File[]) => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<ITicketMessageResponse> => {
        let ticket = getState().ticketing.ticket;

        let ccList = cc.map(x => {
            let id = parseInt(x.value);

            return { id: isNaN(id) ? 0 : id, fullName: '', email: x.email }
        });

        let bccList = bcc.map(x => {
            let id = parseInt(x.value);

            return { id: isNaN(id) ? 0 : id, fullName: '', email: x.email }
        });

        let formData = new FormData();

        formData.append('id', '0');
        formData.append('ticketId', ticket.id.toString());
        formData.append('parentMessageId', parentMessageId.toString());
        formData.append('createdDateTime', '');
        formData.append('visibility', visibility.toString());
        formData.append('subject', subject);
        formData.append('message', message);
        formData.append('from', from);
        formData.append('to', to.email);

        cc.forEach(item => {
            formData.append('cc', item.email);
        });

        bcc.forEach(item => {
            formData.append('bcc', item.email);
        });

        files.forEach(file => {
            formData.append('files', file);
        });

        formData.append('type', type.toString());

        let options = {
            url: __API__ + '/ticketing/message',
            data: formData
        };

        return dispatch<any>(AuthActionCreators.apiPostFormData(options)).then((response: ITicketMessageResponse) => {
            if (response.data.success)
                dispatch<any>(ActionCreators.addTicketMessage(response.data.results));

            return Promise.resolve(response);
        });
    },
    saveTicketForward: (from: string, to: ISelectItem[], cc: ISelectItem[], bcc: ISelectItem[], subject: string, message: string, visibility: TicketVisibility, parentMessageId: number, files: File[]) => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<ITicketMessageResponse> => {
        let ticket = getState().ticketing.ticket;

        let toList = to.map(x => {
            let id = parseInt(x.value);
            return { id: isNaN(id) ? 0 : id, fullName: '', email: x.email != undefined ? x.email : x.label }
        });

        let ccList = cc.map(x => {
            let id = parseInt(x.value);
            return { id: isNaN(id) ? 0 : id, fullName: '', email: x.email != undefined ? x.email : x.label }
        });

        let bccList = bcc.map(x => {
            let id = parseInt(x.value);
            return { id: isNaN(id) ? 0 : id, fullName: '', email: x.email != undefined ? x.email : x.label }
        });

        let formData = new FormData();

        formData.append('id', '0');
        formData.append('ticketId', ticket.id.toString());
        formData.append('parentMessageId', parentMessageId.toString());
        formData.append('createdDateTime', '');
        formData.append('visibility', visibility.toString());
        formData.append('subject', subject);
        formData.append('message', message);
        formData.append('from', from);

        toList.forEach(item => {
            formData.append('to', item.email);
        });

        ccList.forEach(item => {
            formData.append('cc', item.email);
        });

        bccList.forEach(item => {
            formData.append('bcc', item.email);
        });

        files.forEach(file => {
            formData.append('files', file);
        });

        let options = {
            url: __API__ + '/ticketing/forward',
            data: formData
        };

        return dispatch<any>(AuthActionCreators.apiPostFormData(options)).then((response: ITicketMessageResponse) => {
            if (response.data.success)
                dispatch<any>(ActionCreators.addTicketMessage(response.data.results));

            return Promise.resolve(response);
        });
    },
    saveTicketNote: (to: ISelectItem, message: string, visibility: TicketVisibility, parentMessageId: number, files: File[]) => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<ITicketMessageResponse> => {
        let ticket = getState().ticketing.ticket;

        let formData = new FormData();

        formData.append('id', '0');
        formData.append('ticketId', ticket.id.toString());
        formData.append('parentMessageId', parentMessageId.toString());
        formData.append('createdDateTime', '');
        formData.append('visibility', visibility.toString());
        formData.append('message', message);
        formData.append('to', to.email);

        files.forEach(file => {
            formData.append('files', file);
        });

        formData.append('type', '2');

        let options = {
            url: __API__ + '/ticketing/note',
            data: formData
        };

        return dispatch<any>(AuthActionCreators.apiPostFormData(options)).then((response: ITicketMessageResponse) => {
            if (response.data.success)
                dispatch<any>(ActionCreators.addTicketMessage(response.data.results));

            return Promise.resolve(response);
        });
    },
    addTicketMessage: (message: ITicketMessage) => {
        return {
            type: ActionTypes.ADD_TICKET_MESSAGE,
            message
        };
    },
    changeTicketStatus: (ticketId: number, ticketStatus: TicketStatus) => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<IBaseResponse> => {
        let ticket = getState().ticketing.tickets.find(x => x.id == ticketId);
        ticket.ticketStatusId = ticketStatus;

        let options: IPut = {
            url: __API__ + '/ticketing/ticket',
            data: {
                id: ticket.id,
                groupId: ticket.groupId,
                assignedUserId: ticket.assignedUserId,
                entityType: ticket.entityType,
                entityTypeId: ticket.entityTypeId,
                ticketStatusId: ticket.ticketStatusId,
                ticketTypeId: ticket.ticketTypeId,
                tierlevelId: ticket.tierLevelId,
                urgency: ticket.urgencyId,
                tags: ticket.tags.map(x => x.tag)
            }
        };

        return dispatch<any>(AuthActionCreators.apiPut(options)).then((response: IBaseResponse) => {

            return Promise.resolve(response);
        });
    },
    updateTicketStatus: (ticketId: number, ticketStatus: TicketStatus) => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<IBaseResponse> => {
        let options: IPut = {
            url: __API__ + '/ticketing/ticket/status',
            data: {
                id: ticketId,
                ticketStatusId: ticketStatus
            }
        };

        return dispatch<any>(AuthActionCreators.apiPut(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    updateTicketGroup: (ticketId: number, groupId: number) => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<IBaseResponse> => {
        let options: IPut = {
            url: __API__ + '/ticketing/ticket/group',
            data: {
                id: ticketId,
                groupId
            }
        };

        return dispatch<any>(AuthActionCreators.apiPut(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    changeAssignedUser: (ticketId: number, userId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/ticketing/ticket/assigned-user/${ticketId}/${userId}`,
        };

        return dispatch<any>(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    updateAssignedUser: (ticketId: number, userId: number) => {
        return {
            type: ActionTypes.UPDATE_ASSIGNED_USER,
            ticketId,
            userId
        };
    },

    getTickets: (request: ITicketListRequest, forCenter: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<ITicketListResponse> => {
        let options = {
            url: `${__API__}/ticketing/ticket/list?forCenter=${forCenter}`,
            data: request
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    exportTickets: (request: ITicketListRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let options = {
            url: `${__API__}/ticketing/ticket/export`,
            responseType: 'blob',
            data: request
        };

        return await dispatch<any>(AuthActionCreators.apiPost(options));
    },

    getTicketGroupCategoryList: () => (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: __API__ + '/ticketing/group/category'
        };

        return dispatch<any>(AuthActionCreators.apiGet(options)).then((response: ITicketGroupCategoryListResponse) => {
            if (response.data.success)
                dispatch<any>(ActionCreators.setTicketGroupCategoryList(response.data.results));

            return Promise.resolve(response);
        });
    },
    setTicketGroupCategoryList: (list: ITicketGroupCategory[]) => {
        return {
            type: ActionTypes.SET_TICKET_GROUP_CATEGORY_LIST,
            list
        };
    },
    getTicketGroups: () => (dispatch: Dispatch<IApplicationState>): Promise<ITicketGroupListResponse> => {
        let options = {
            url: __API__ + '/ticketing/group'
        };

        return dispatch<any>(AuthActionCreators.apiGet(options)).then((response: ITicketGroupListResponse) => {
            if (response.data.success)
                dispatch<any>(ActionCreators.setTicketGroupList(response.data.results));

            return Promise.resolve(response);
        });
    },
    setTicketGroupList: (list: ITicketGroup[]) => {
        return {
            type: ActionTypes.SET_TICKET_GROUPS,
            list
        };
    },
    saveTicketGroup: (group: ITicketGroup) => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<ITicketGroupResponse> => {
        let options = {
            url: __API__ + '/ticketing/group',
            data: group
        }

        if (group.id == 0) {
            return dispatch<any>(AuthActionCreators.apiPost(options)).then((response: ITicketGroupResponse) => {
                if (response.data.success)
                    dispatch<any>(ActionCreators.addTicketGroupToList(response.data.results));

                return Promise.resolve(response);
            });
        } else {
            return dispatch<any>(AuthActionCreators.apiPut(options)).then((response: ITicketGroupResponse) => {
                if (response.data.success)
                    dispatch<any>(ActionCreators.updateTicketGroupList(response.data.results));

                return Promise.resolve(response);
            });
        }
    },
    deleteTicketGroup: (groupId: number) => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<IBaseResponse> => {
        let options: IDelete = {
            url: __API__ + '/ticketing/group/' + groupId
        }

        return dispatch<any>(AuthActionCreators.apiDelete(options)).then((response: ITicketGroupResponse) => {
            if (response.data.success)
                dispatch<any>(ActionCreators.removeTicketGroupFromList(groupId));

            return Promise.resolve(response);
        });
    },
    addTicketGroupToList: (group: ITicketGroup) => {
        return {
            type: ActionTypes.ADD_TICKET_GROUP,
            group
        };
    },
    removeTicketGroupFromList: (groupId: number) => {
        return {
            type: ActionTypes.REMOVE_TICKET_GROUP,
            groupId
        };
    },
    updateTicketGroupList: (group: ITicketGroup) => {
        return {
            type: ActionTypes.UPDATE_TICKET_GROUPS,
            group
        };
    },

    saveTicketGroupUsers: (request: ITicketGroupUsersRequest) => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<ITicketGroupResponse> => {
        let options = {
            url: __API__ + '/ticketing/group/users',
            data: request
        }

        return dispatch<any>(AuthActionCreators.apiPost(options)).then((response: ITicketGroupResponse) => {
            if (response.data.success)
                dispatch<any>(ActionCreators.updateTicketGroupList(response.data.results));

            return Promise.resolve(response);
        });
    },

    getUserList: (groups: number[]) => (dispatch: Dispatch<IApplicationState>): Promise<IUserListResponse> => {
        let options = {
            url: __API__ + '/user/by-group/' + groups.join(',')
        };

        return dispatch<any>(AuthActionCreators.apiGet(options)).then((response: IUserListResponse) => {
            if (response.data.success)
                dispatch<any>(ActionCreators.setUserList(response.data.results));

            return Promise.resolve(response);
        });
    },
    setUserList: (list: IUser[]) => {
        return {
            type: ActionTypes.SET_USER_LIST,
            list
        };
    },

    getLookupData: () => (dispatch: Dispatch<IApplicationState>): Promise<ITicketLookupDataResponse> => {
        let options = {
            url: `${__API__}/ticketing/lookup-data`
        };

        return dispatch<any>(AuthActionCreators.apiGet(options)).then((response: ITicketLookupDataResponse) => {
            if (response.data.success)
                dispatch<any>(ActionCreators.setLookupData(response.data.results));

            return Promise.resolve(response);
        });
    },
    setLookupData: (lookupData: ITicketingLookupData) => {
        return {
            type: ActionTypes.SET_TICKETING_LOOKUP_DATA,
            lookupData
        };
    },

    saveCenterTicket: (subject: string, message: string, ticketType: TicketType, urgency: TicketUrgency, files: File[]) => (dispatch: Dispatch<IApplicationState>): Promise<ITicketResponse> => {
        let formData = new FormData();

        formData.append('subject', subject);
        formData.append('message', message);
        formData.append('ticketType', ticketType.toString());
        formData.append('urgency', urgency.toString());

        files.forEach(file => {
            formData.append('files', file);
        });

        let options = {
            url: __API__ + '/ticketing/ticket/center',
            data: formData
        };

        return dispatch<any>(AuthActionCreators.apiPostFormData(options)).then((response: ITicketResponse) => {
            return Promise.resolve(response);
        });
    },
    saveCenterMessage: (ticketId: number, subject: string, message: string) => (dispatch: Dispatch<IApplicationState>): Promise<ITicketMessageResponse> => {
        let options = {
            url: `${__API__}/ticketing/message/center`,
            data: {
                ticketId,
                subject,
                message
            }
        };

        return dispatch<any>(AuthActionCreators.apiPost(options)).then((response: ITicketMessageResponse) => {
            return Promise.resolve(response);
        });
    },
    updateCenterTicket: (id: number, subject: string, message: string, files: File[]) => (dispatch: Dispatch<IApplicationState>): Promise<ITicketResponse> => {
        // let options = {
        //     url: `${__API__}/ticketing/ticket/center`,
        //     data: {
        //         id,
        //         subject,
        //         message
        //     }
        // };

        let formData = new FormData();

        formData.append('id', id.toString());
        formData.append('subject', subject);
        formData.append('message', message);
        
        files.forEach(file => {
            formData.append('files', file);
        });

        let options = {
            url: __API__ + '/ticketing/ticket/center',
            data: formData
        };

        return dispatch<any>(AuthActionCreators.apiPutFormData(options)).then((response: ITicketResponse) => {
            return Promise.resolve(response);
        });
    },

    updateAttachments: (file: File) => {
        return {
            type: ActionTypes.UPDATE_ATTACHMENTS,
            file
        };
    },

    getTags: () => (dispatch: Dispatch<IApplicationState>): Promise<ITagListResponse> => {
        var options = {
            url: `${__API__}/ticketing/tag`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: ITagListResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getCannedResponses: () => (dispatch: Dispatch<IApplicationState>): Promise<ICannedResponseListResponse> => {
        var options = {
            url: `${__API__}/ticketing/canned-response`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: ICannedResponseListResponse) => {
                if (response.data.success)
                    dispatch<any>(ActionCreators.setCannedResponse(response.data.results));

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    setCannedResponse: (list: ITicketCannedResponse[]) => {
        return {
            type: ActionTypes.SET_CANNED_RESPONSES,
            list
        };
    },
    getCannedResponse: (id: number) => (dispatch: Dispatch<IApplicationState>): Promise<ICannedResponseResponse> => {
        var options = {
            url: `${__API__}/ticketing/canned-response/${id}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: ICannedResponseResponse) => {
                // if (response.data.success)
                //     dispatch<any>(ActionCreators.setCannedResponse(response.data.results));

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    saveCannedResponse: (response: ITicketCannedResponseRequest) => (dispatch: Dispatch<IApplicationState>): Promise<ICannedResponseResponse> => {
        let options = {
            url: `${__API__}/ticketing/canned-response`,
            data: response
        };

        if (response.id == 0) {
            return dispatch<any>(AuthActionCreators.apiPost(options)).then((response: ICannedResponseResponse) => {
                return Promise.resolve(response);
            });
        } else {
            return dispatch<any>(AuthActionCreators.apiPut(options)).then((response: ICannedResponseResponse) => {
                return Promise.resolve(response);
            });
        }
    },
    deleteCannedResponse: (id: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/ticketing/canned-response/${id}`
        };

        return dispatch<any>(AuthActionCreators.apiDelete(options)).then((response: IBaseResponse) => {
            if (response.data.success)
                dispatch<any>(ActionCreators.removeCannedResponseFromList(id));

            return Promise.resolve(response);
        });
    },
    removeCannedResponseFromList: (id: number) => {
        return {
            type: ActionTypes.REMOVE_CANNED_RESPONSE,
            id
        };
    }
}

interface ISetTicket {
    type: string,
    ticket: ITicket
}

interface IUpdateTicket {
    type: string,
    property: TicketProperty,
    value: string
}

interface IUpdateTicketTags {
    type: string,
    list: ISelectItem[]
}

interface ISetTicketList {
    type: string,
    list: ITicket[]
}

interface ISetTicketGroupList {
    type: string,
    list: ITicketGroup[]
}

interface IUpdateTicketGroupList {
    type: string,
    group: ITicketGroup
}

interface IAddTicketGroupToList {
    type: string,
    group: ITicketGroup
}

interface IRemoveTicketGroupFromList {
    type: string,
    groupId: number
}

interface ISetUserList {
    type: string,
    list: IUser[]
}

interface IAddTicketMessage {
    type: string,
    message: ITicketMessage
}

interface ISetTicketGroupCategoryList {
    type: string,
    list: ITicketGroupCategory[]
}

interface ISetLookupData {
    type: string,
    lookupData: ITicketingLookupData
}

interface IUpdateAssignedUser {
    type: string,
    ticketId: number,
    userId: number
}

interface IUpdateAttachments {
    type: string,
    file: File
}

interface ISetCannedResponses {
    type: string,
    list: ITicketCannedResponse[]
}

interface IRemoveCannedResponseFromList {
    type: string,
    id: number
}

const setTicket = (state: ITicketingState, action: ISetTicket) => {
    state.ticket = action.ticket;
    return state;
}

const updateTicket = (state: ITicketingState, action: IUpdateTicket) => {
    switch (action.property) {
        case TicketProperty.AssignedUser:
            state.ticket.assignedUserId = parseInt(action.value);
            break;

        case TicketProperty.TicketType:
            let currentType = state.ticket.ticketTypeId;
            let newType = parseInt(action.value);

            state.ticket.ticketTypeId = parseInt(action.value);
            state.ticket.entityType = newType == TicketType.ContactPageNonMemberCenter || newType == TicketType.MemberCenterRequest ? TicketEntityType.Center : 0;
            state.ticket.entityTypeId = currentType != newType ? 0 : state.ticket.entityTypeId;

            break;

        case TicketProperty.Center:
            state.ticket.entityType = TicketEntityType.Center;
            state.ticket.entityTypeId = parseInt(action.value);
            break;

        case TicketProperty.TierLevel:
            state.ticket.tierLevelId = parseInt(action.value);
            break;

        case TicketProperty.TicketStatus:
            state.ticket.ticketStatusId = parseInt(action.value);
            break;

        case TicketProperty.Group:
            state.ticket.groupId = parseInt(action.value);
            break;

        case TicketProperty.Urgency:
            state.ticket.urgencyId = parseInt(action.value);
            break;
    }

    return state;
}

const updateTicketTags = (state: ITicketingState, action: IUpdateTicketTags) => {
    state.ticket.tags = action.list != null ? action.list.map(x => { return { id: parseInt(x.value), tag: x.label }; }) : [];
    return state;
}

const addTicketMessage = (state: ITicketingState, action: IAddTicketMessage) => {
    state.ticket.messages.push(action.message);
    return state;
}

const setTicketList = (state: ITicketingState, action: ISetTicketList) => {
    state.tickets = action.list;
    return state;
}

const setTicketGroupList = (state: ITicketingState, action: ISetTicketGroupList) => {
    state.groups = action.list;
    return state;
}

const addTicketGroupToList = (state: ITicketingState, action: IAddTicketGroupToList) => {
    state.groups.push(action.group);
    return state;
}

const removeTicketGroupFromList = (state: ITicketingState, action: IRemoveTicketGroupFromList) => {
    state.groups = state.groups.filter(x => x.id != action.groupId);
    return state;
}

const updateTicketGroupList = (state: ITicketingState, action: IUpdateTicketGroupList) => {
    state.groups = state.groups.map(group => {
        if (group.id == action.group.id)
            return action.group
        else
            return group;
    });

    return state;
}

const setUserList = (state: ITicketingState, action: ISetUserList) => {
    state.users = action.list;
    return state;
}

const setTicketGroupCategoryList = (state: ITicketingState, action: ISetTicketGroupCategoryList) => {
    state.categories = action.list;
    return state;
}

const setLookupData = (state: ITicketingState, action: ISetLookupData) => {
    state.lookupData = action.lookupData;
    return state;
}

const updateAssignedUser = (state: ITicketingState, action: IUpdateAssignedUser) => {
    state.tickets = state.tickets.map(ticket => {
        if (ticket.id == action.ticketId) {
            ticket.assignedUser = state.lookupData.userList.find(x => x.id == action.userId);
            ticket.assignedUserId = action.userId;
        }

        return ticket;
    });

    return state;
}

const setCannedResponses = (state: ITicketingState, action: ISetCannedResponses) => {
    state.cannedResponses = action.list;
    return state;
}

const removeCannedResponseFromList = (state: ITicketingState, action: IRemoveCannedResponseFromList) => {
    state.cannedResponses = state.cannedResponses.filter(x => x.id != action.id);
    return state;
}

let initialState: ITicketingState = {
    ticket: null,
    tickets: [],
    groups: [],
    users: [],
    categories: [],
    cannedResponses: [],
    lookupData: {
        ticketEntityTypeList: [],
        ticketTypeList: [],
        ticketGroupList: [],
        ticketTierList: [],
        ticketStatusList: [],
        ticketUrgencyList: [],
        userList: [],
        centerList: [],
        tagList: [],
        nkrContactList: []
    }
};

type TActions =
    ISetTicket
    & IUpdateTicket
    & IUpdateTicketTags
    & IAddTicketMessage
    & ISetTicketList
    & ISetTicketGroupList
    & ISetUserList
    & IAddTicketGroupToList
    & IRemoveTicketGroupFromList
    & IRemoveTicketGroupFromList
    & IUpdateTicketGroupList
    & ISetTicketGroupCategoryList
    & ISetLookupData
    & IUpdateAssignedUser
    & IUpdateAttachments
    & ISetCannedResponses
    & IRemoveCannedResponseFromList
    ;

interface ITicketingHandlers {
    [x: string]:
    ((state: ITicketingState, action: ISetTicket) => ITicketingState)
    | ((state: ITicketingState, action: IUpdateTicket) => ITicketingState)
    | ((state: ITicketingState, action: IUpdateTicketTags) => ITicketingState)
    | ((state: ITicketingState, action: IAddTicketMessage) => ITicketingState)
    | ((state: ITicketingState, action: ISetTicketList) => ITicketingState)
    | ((state: ITicketingState, action: ISetTicketGroupList) => ITicketingState)
    | ((state: ITicketingState, action: ISetUserList) => ITicketingState)
    | ((state: ITicketingState, action: IAddTicketGroupToList) => ITicketingState)
    | ((state: ITicketingState, action: IRemoveTicketGroupFromList) => ITicketingState)
    | ((state: ITicketingState, action: IUpdateTicketGroupList) => ITicketingState)
    | ((state: ITicketingState, action: ISetTicketGroupCategoryList) => ITicketingState)
    | ((state: ITicketingState, action: ISetLookupData) => ITicketingState)
    | ((state: ITicketingState, action: IUpdateAssignedUser) => ITicketingState)
    | ((state: ITicketingState, action: IUpdateAttachments) => ITicketingState)
    | ((state: ITicketingState, action: ISetCannedResponses) => ITicketingState)
    | ((state: ITicketingState, action: IRemoveCannedResponseFromList) => ITicketingState)
}

const createReducer = (initialState: ITicketingState, handlers: ITicketingHandlers) => {
    return function reducer(state = initialState, action: TActions) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = _.cloneDeep(state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers: ITicketingHandlers = {
    [ActionTypes.SET_TICKET]: setTicket,
    [ActionTypes.UPDATE_TICKET]: updateTicket,
    [ActionTypes.UPDATE_TICKET_TAGS]: updateTicketTags,
    [ActionTypes.ADD_TICKET_MESSAGE]: addTicketMessage,
    [ActionTypes.SET_TICKET_LIST]: setTicketList,
    [ActionTypes.SET_TICKET_GROUPS]: setTicketGroupList,
    [ActionTypes.SET_USER_LIST]: setUserList,
    [ActionTypes.ADD_TICKET_GROUP]: addTicketGroupToList,
    [ActionTypes.REMOVE_TICKET_GROUP]: removeTicketGroupFromList,
    [ActionTypes.UPDATE_TICKET_GROUPS]: updateTicketGroupList,
    [ActionTypes.SET_TICKET_GROUP_CATEGORY_LIST]: setTicketGroupCategoryList,
    [ActionTypes.SET_TICKETING_LOOKUP_DATA]: setLookupData,
    [ActionTypes.UPDATE_ASSIGNED_USER]: updateAssignedUser,
    [ActionTypes.SET_CANNED_RESPONSES]: setCannedResponses,
    [ActionTypes.REMOVE_CANNED_RESPONSE]: removeCannedResponseFromList
}

export const Reducer = createReducer(initialState, handlers);